import { render, staticRenderFns } from "./SidebarPostSeries.vue?vue&type=template&id=682132a3&"
import script from "./SidebarPostSeries.vue?vue&type=script&lang=js&"
export * from "./SidebarPostSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports